import { Burger } from '../core'

export default {
  burger: undefined,

  init() {
    /* Burger */
    let obj = this
    obj.burger = new Burger('.burger', {
      onToggle: function() {
        if (obj.burger.isExpanded) {
          $('body').addClass('--menu-open')
        } else {
          $('body').removeClass('--menu-open')
        }
      },
    })

    /* Submenu parent */
    $('header .navigation .main-menu > li.main-menu__item--parent').each(function() {
      $(this).SubMenuParent({
        mobile: false,
      });
    })

    /* Calculate header height */
    $(window).on('resize load orientationchange', header)
    header()

    /* Language display */
    $.mlmi.mobile.add(function() {
      $('.wpml-ls-native[lang="en"]').text('Switch to english')
      $('.wpml-ls-native[lang="fr"]').text('Passer en français')
    }, function() {
      $('.wpml-ls-native[lang="en"]').text('EN')
      $('.wpml-ls-native[lang="fr"]').text('FR')
    })
  }
}
